import { render } from "./ProgressQuarterIcon.vue?vue&type=template&id=e0b79d2c&ts=true"
import script from "./ProgressQuarterIcon.vue?vue&type=script&lang=ts"
export * from "./ProgressQuarterIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__